<template>
  <div class="newPriceContainer">
    <template v-if="data.length == 1">
      <i class="icon-wallet icons text-green big-icon"></i>
      <p class="price has-text-right">
        USD ${{ data[0].number }}
      </p>
    </template>
    <template v-else>
      <i class="icon-wallet icons text-green big-icon"></i>
      <template v-for="price in data">
        <p class="price has-text-right" v-if="price.type == 2">
          USD ${{ price.number }}
        </p>
        <p class="price discount has-text-right" v-if="price.type == 1">
          USD ${{ price.number }}
        </p>
      </template>
      <p class="price aux">*o el cambio a tu moneda local</p>
    </template>
  </div>
</template>
<script>
  export default {
    props: [
      'data'
    ]
  }
</script>
<style lang="sass" scoped>
  .newPriceContainer
    align-items: center
    display: flex
    flex-direction: column
    justify-content: center

    i.icons
      color: #009688
      font-size: 8rem

    p.price
      color: #01447e
      font-size: 2rem
      font-weight: bold
      line-height: 2rem

      &.discount
        color: #999
        font-size: 1.2rem
        text-decoration: line-through solid #999

      &.aux
        color: #666
        font-size: 1.2rem
</style>



// WEBPACK FOOTER //
// component.vue?3a1566b8